import { ClientError } from './client-error';

export class AssessmentTypeInitializationError extends ClientError {
  constructor(message: string) {
    super(message);

    this.name = 'AssessmentTypeInitializationError';
  }
}
